// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__1rHEH","info":"Note_info__2EI0e","note":"Note_note__3cOxo","actions":"Note_actions__3rfvC"};